module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"company_description":"This informations will be used in your company invoice","thankyou":{"title":"Edit Thank You message","placeholder":"Write your Thank You message here."}},"id":{"company_description":"Informasi ini akan digunakan dalam invoice perusahaan","thankyou":{"title":"Sunting pesan Terima Kasih","placeholder":"Tulis pesan Terima Kasih Anda di sini."}}}')
  delete Component.options._Ctor
}
